import {Component, OnInit} from "@angular/core";
import {Router, ActivationEnd} from "@angular/router";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    host: {
        "[class.collapsed]": "isCollapsed",
        "[class.hidden]": "isHidden",
    },
    standalone: false
})
export class SidebarComponent implements OnInit {
  isCollapsed: boolean;
  isHidden: boolean; // can be hidden based on current route
  routeName: string; // name of current route

  constructor(private router: Router) {
  }

  // determine which menu context to show based on the current route
  ngOnInit() {

    this.router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        // hide sidebar based on current route. hideSidebar is set in route config
        this.isHidden = event.snapshot.data.hideSidebar;

        // keep current sidebar
        // if (event.snapshot.data.retainSidebar) return false;

        // determine the menu context based on the current route
        if (this.routeName !== event.snapshot.data.routeName) this.routeName = event.snapshot.data.routeName;
      }
    });

  }

  // the side can be toggle via an event emitter
  toggleSidebar(toggle?: boolean) {
    setTimeout(() => {
      this.isCollapsed = typeof(toggle) === "boolean" ? toggle : !this.isCollapsed;
    });
  }

}
